import { render, staticRenderFns } from "./SelectIcon.vue?vue&type=template&id=16566c98&lang=pug&"
import script from "./SelectIcon.vue?vue&type=script&lang=js&"
export * from "./SelectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports